import { render, staticRenderFns } from "./ThgQuickCheckout.vue?vue&type=template&id=e8c36a04&scoped=true&"
import script from "./ThgQuickCheckout.vue?vue&type=script&lang=ts&"
export * from "./ThgQuickCheckout.vue?vue&type=script&lang=ts&"
import style0 from "./ThgQuickCheckout.vue?vue&type=style&index=0&id=e8c36a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c36a04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardText,VImg,VWindow,VWindowItem})
